module.exports = __webpack_public_path__ + "assets_1789460829583/img/pic_8.bc65c1d3.png";